/**
 * @author mll
 * 2020-04-29
 * 考试模版组查看
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizContainer,WizReduxTemplate, modelUtils } = framework_tool;
let { WizCard, WizCol, WizRow, WizTypography, WizTable, WizSurveyAudience, WizSpin } = component_tool
import { templateConfig, reduxTemplateConfig } from "./config";
let { Session } = utils_tool
let { Paragraph } = WizTypography

const getParamRecord = (history) => {
    let record = {}
    if (history.location) {
        if (history.location.pathname === '/online/examTemplateGroup/examTempGroupManage') {
            if (history.location && history.location.record) {
                record = history.location.record
                Session.set('examTempGroupManage', record)
            } else {
                record = Session.get('examTempGroupManage') || {}
            }
        }
    }
    return record
}

class ExamTempGroupManage extends WizContainer {
    componentName = 'ExamTempGroupManage';

    constructor(props) {
        super(props)
        this.state = {
            record: getParamRecord(props.history)
        }
    }

    _handleCMD(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o['success']) {
          wizNotice.success(o['msg'])
          return true;
        } else {
          wizNotice.error(o['msg'])
          return false;
        }
      }
    _componentWillMount = () => {
    };



    _render() {
        let { record } = this.state;
        let _reduxTemplateCofig = reduxTemplateConfig({
          templateConfig:templateConfig(record['id']),
          examTemplateGroupId:record['id'],
          apiDataFormat: {
            add: this._handleCMD,
            update: this._handleCMD,
            delete: this._handleCMD,
            enable: this._handleCMD,
          },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}
const mapStateToProps = (state, ownProps) => {
    // const authInfo = modelUtils.getModelEntity(state['examTemplateGroup'], "authInfoKey");
    // const load = modelUtils.getLoadingState(state, 'examTemplateGroup');
    // return { authInfo, ...load }
};

export default connect(mapStateToProps)(ExamTempGroupManage);
